import { render, staticRenderFns } from "./RecipeDetail.vue?vue&type=template&id=1fd9dfb0&"
import script from "./RecipeDetail.vue?vue&type=script&lang=js&"
export * from "./RecipeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports